module.exports = __webpack_public_path__ + "assets/wma.png";